import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import styles from "../../../styles/common-media-styles.module.css";
import React from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import {
  Article,
  EdsData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { MediaItemType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemType";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { MediaItemCardWithActionsInnerChild } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActionsInnerChild";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";

interface MediaItemCardWithActionsProps<T extends Article | AggregatedArticle> {
  item: Item;
  badges?: ItemBadge[];
  edsData: EdsData | null;
  article: T;
  renderActions?: () => React.ReactNode;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  mediaItemType?: MediaItemType;
  itemCardRenderType?: ItemCardRenderType;
  mediaItemViewType?: MediaItemViewType;
}

export const MediaItemCardWithActions = <
  T extends Article | AggregatedArticle,
>({
  item,
  edsData,
  badges,
  article,
  renderActions,
  shouldDisplayQuantity = false,
  totalQuantityPieces,
  mediaItemType = MediaItemType.REGULAR_ITEM,
  itemCardRenderType = ItemCardRenderType.link,
  mediaItemViewType,
}: MediaItemCardWithActionsProps<T>) => {
  const navigationUrl =
    mediaItemViewType === MediaItemViewType.AGGREGATED_ITEM_VIEW
      ? `/mediamaintenance/medias/${article.mediaId}/articles/${article.id}/product_article_id/${article.productArticleId}?media-item-type=${mediaItemType}`
      : `/mediamaintenance/articles/${article.id}?media-item-type=${mediaItemType}`;

  return (
    <ItemCard
      badges={badges as ItemBadge[]}
      dataTestId="media-item-card-with-actions"
    >
      {itemCardRenderType === ItemCardRenderType.link ? (
        <FixaLink to={navigationUrl} className={styles["item-card-root-row"]}>
          <MediaItemCardWithActionsInnerChild
            item={item}
            shouldDisplayQuantity={shouldDisplayQuantity}
            totalQuantityPieces={totalQuantityPieces || 0}
            edsData={edsData ?? null}
          />
        </FixaLink>
      ) : (
        <div className={styles["item-card-root-row"]}>
          <MediaItemCardWithActionsInnerChild
            itemCardRenderType={itemCardRenderType}
            item={item}
            shouldDisplayQuantity={shouldDisplayQuantity}
            totalQuantityPieces={totalQuantityPieces || 0}
            edsData={edsData ?? null}
          />
        </div>
      )}
      {renderActions && renderActions()}
    </ItemCard>
  );
};
